<template>
  <!-- 添加编辑弹窗 -->
  <el-dialog title="一级分类"
             :visible.sync="categoryShow"
             width="800px"
             class="firstChild"
             :close-on-click-modal="false"
             :show-close="false">
    <div class="diabox">
      <el-form :model="info"
               :rules="rules"
               ref="ruleForm"
               label-width="100px">
        <el-form-item label="排序">
          <el-input-number v-model="info.sort"
                           step-strictly
                           :step="1"
                           :min="0"
                           :max="1000000000"
                           :controls="false"
                           placeholder="请输入排序"></el-input-number>
          <span style="margin-left:10px;color:#999">数字越大，排名越靠前,如果为空，默认排序方式为创建时间</span>
        </el-form-item>

        <el-form-item label="分类名称"
                      prop="conditioning_name">
          <el-input v-model="info.conditioning_name"
                    maxlength="20"
                    style="width:280px"
                    placeholder="请输入..."></el-input>
        </el-form-item>
        <el-form-item label="是否显示">
          <el-radio-group v-model="info.is_visible">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>

      </el-form>
    </div>
    <div style="text-align:right;padding:0 50px 20px 0">
      <span slot="footer"
            class="dialog-footer">
        <el-button type="info"
                   @click="close"
                   style="width:92px">取消</el-button>
        <el-button type="primary"
                   @click="submit"
                   style="width:92px">保 存</el-button>
      </span>
    </div>
  </el-dialog>
</template>

<script>
import toningPlan from '../../../../api/toningPlan.js';
export default {
  name: 'firstChild',
  data() {
    return {
      categoryShow: true,
      info: {
        sort: undefined,
        conditioning_name: '',
        is_visible: 1
      },
      rules: {
        conditioning_name: [
          { required: true, message: '请输入分类名称', trigger: 'blur' },
          { min: 1, max: 20, message: '分类名称20位字符以内', trigger: 'blur' }
        ]
      },
    };
  },
  props: {
    oldInfo: {
      required: true,
      type: Object,
      default: function () {
        return {};
      }
    }
  },
  components: {
    'el-image-viewer': () =>
      import('element-ui/packages/image/src/image-viewer')
    // HistoryImg,
    // ChooseGood
  },
  created() {
    this.info = Object.assign(this.info,this.oldInfo);
  },
  methods: {
    close() {
      this.$emit('close');
    },
    submit() {
      let check = false;
      this.$refs.ruleForm.validate((valid) => {
        check = valid;
      });
      if (!check) {
        return;
      }
      let params = Object.assign(this.oldInfo, this.info);
      console.log(params);
      let urlName = !this.oldInfo.conditioning_id
        ? 'saveConditioningInfo'
        : 'editConditioningInfo';
      let msg = !this.oldInfo.conditioning_id ? '添加成功' : '修改成功';
      toningPlan[urlName](params).then((res) => {
        let { code } = res;
        if (code == 0) {
          this.$message.success(msg);
          this.$parent.getList();
          this.close();
        }
      });
    }
  }
};
</script>

<style lang='scss' scoped>
.diabox {
  padding: 20px 20px 0;
  overflow: auto;
  max-height: 60vh;
}
.uploadimg {
  width: 200px;
  height: 200px;
  background-color: #fff;
  border: solid 1px #d6d6d6;
  overflow: hidden;
  box-sizing: border-box;
  .avatar {
    width: 200px;
    height: 200px;
  }
  .icobox {
    width: 200px;
    height: 200px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .uploader-icon {
    font-size: 30px;
    color: #d6d6d6;
  }
}
.tip {
  color: #999;
  margin: 15px 0;
}
.box {
  position: relative;
  padding-left: 100px;
  &:hover .shadow {
    display: flex;
  }
  img {
    width: 200px;
    height: 200px;
  }
  .shadow {
    position: absolute;
    left: 100px;
    top: 0;
    width: 200px;
    height: 200px;
    background-color: rgba(0, 0, 0, 0.6);
    display: none;
  }
  i + i {
    margin-left: 30px;
    color: #d44747;
  }
  i {
    color: #ffffff;
    font-size: 30px;
    text-align: center;
    cursor: pointer;
  }
}
</style>
<style lang="scss">
.firstChild {
  .el-input-number input {
    text-align: left !important;
  }
}
</style>
